import { useNavigate } from 'react-router-dom';

interface Props {
  /** Font Awesome 아이콘 클래스 (예: "fas fa-exclamation-triangle") */
  icon?: string;
  message: string;
  subMessage?: string;
  backTo: string;
  backLabel?: string;
}

/**
 * 상세 페이지에서 데이터를 찾을 수 없을 때 보여주는 빈 화면.
 * AdverDetail · NoticeDetail 두 곳에서 동일 구조가 반복됐기 때문에 추출.
 */
export default function EmptyDetailState({
  icon = 'fas fa-exclamation-triangle',
  message,
  subMessage = '목록에서 항목을 선택해주세요',
  backTo,
  backLabel = '목록으로 돌아가기',
}: Props) {
  const navigate = useNavigate();
  return (
    <div className="text-center py-12">
      <i className={`${icon} text-6xl text-gray-300 mb-4`}></i>
      <p className="text-gray-600 mb-4">{message}</p>
      <p className="text-sm text-gray-500 mb-4">{subMessage}</p>
      <button
        onClick={() => navigate(backTo)}
        className="px-5 py-2.5 bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors"
      >
        {backLabel}
      </button>
    </div>
  );
}
